import type { Translations } from '@/types';

export const fr: Translations = {
  'app.title': 'Simulateur de Page Bloquée Firewall',
  'app.subtitle': 'Plateforme de Formation et Éducation',
  'app.disclaimer': 'Ceci est une page de blocage firewall simulée à des fins de formation uniquement. Aucune violation réelle de politique de sécurité n\'a eu lieu.',
  
  'nav.generator': 'Générateur',
  'nav.dashboard': 'Analytiques',
  'nav.settings': 'Paramètres',
  'nav.help': 'Aide',
  
  'config.basicInfo': 'Informations de Base',
  'config.blockedUrl': 'URL Bloquée',
  'config.category': 'Catégorie',
  'config.firewallMode': 'Mode Firewall',
  'config.organization': 'Nom de l\'Organisation',
  
  'config.networkDetails': 'Détails Réseau',
  'config.firewallName': 'Nom du Firewall',
  'config.ipAddress': 'Adresse IP Client',
  'config.userName': 'Nom d\'Utilisateur (Optionnel)',
  
  'config.errorInfo': 'Informations d\'Erreur',
  'config.errorCode': 'Code d\'Erreur',
  'config.blockType': 'Type de Blocage',
  
  'config.adminContact': 'Contact Administrateur',
  'config.adminEmail': 'Email Admin',
  'config.adminPhone': 'Téléphone Admin',
  'config.adminPortal': 'URL Portail Admin',
  
  'config.technicalDetails': 'Détails Techniques',
  'config.policyId': 'ID Politique',
  'config.firewallSerial': 'Numéro de Série Firewall',
  'config.threatId': 'ID Menace',
  'config.webFilterProfile': 'Profil Filtre Web',
  'config.securityProfile': 'Profil Sécurité',
  'config.sslInspection': 'Inspection SSL',
  'config.actionTaken': 'Action Prise',
  'config.destinationIp': 'IP Destination',
  'config.destinationPort': 'Port Destination',
  'config.protocol': 'Protocole',
  'config.sessionId': 'ID Session',
  
  'config.displayOptions': 'Options d\'Affichage',
  'config.showDisclaimer': 'Afficher l\'Avertissement de Formation',
  'config.showTechnicalDetails': 'Afficher les Détails Techniques',
  'config.showRequestAccess': 'Afficher le Bouton Demande d\'Accès',
  'config.theme': 'Thème',
  'config.language': 'Langue',
  
  'scenarios.title': 'Préréglages de Scénarios',
  'scenarios.malware': 'Site de Distribution de Logiciels Malveillants',
  'scenarios.phishing': 'Tentative de Phishing',
  'scenarios.adultContent': 'Blocage de Contenu Adulte',
  'scenarios.gaming': 'Blocage de Site de Jeux',
  'scenarios.geoBlock': 'Région Géo-Bloquée',
  'scenarios.socialMedia': 'Blocage de Réseaux Sociaux',
  'scenarios.streaming': 'Blocage de Streaming',
  
  'export.title': 'Options d\'Export',
  'export.html': 'Exporter en HTML',
  'export.zip': 'Télécharger le Package ZIP',
  'export.json': 'Exporter Config (JSON)',
  'export.copy': 'Copier HTML dans le Presse-papiers',
  'export.screenshot': 'Générer une Capture d\'Écran',
  
  'preview.title': 'Aperçu',
  'preview.live': 'Aperçu en Direct',
  
  'requestAccess.title': 'Demander l\'Accès',
  'requestAccess.name': 'Votre Nom',
  'requestAccess.email': 'Votre Email',
  'requestAccess.reason': 'Raison de l\'Accès',
  'requestAccess.submit': 'Soumettre la Demande',
  'requestAccess.success': 'Demande soumise avec succès !',
  'requestAccess.ticketId': 'Votre numéro de ticket :',
  
  'training.title': 'Mode Formation',
  'training.enable': 'Activer le Mode Formation',
  'training.tooltip.webFilter': 'Le filtrage web bloque l\'accès aux sites web en fonction de leur catégorie de contenu. Cela aide les organisations à faire respecter les politiques d\'utilisation acceptable.',
  'training.tooltip.category': 'Les catégories de contenu classent les sites web par leur objectif principal. Les catégories comme Logiciels Malveillants, Phishing et Contenu Adulte sont couramment bloquées en entreprise.',
  'training.tooltip.sslInspection': 'L\'inspection SSL déchiffre et analyse le trafic HTTPS crypté pour détecter les menaces qui peuvent être cachées dans les connexions sécurisées.',
  'training.tooltip.policy': 'Les politiques de sécurité définissent quel trafic est autorisé ou bloqué en fonction de divers critères incluant l\'utilisateur, le groupe, l\'heure et la catégorie de contenu.',
  
  'dashboard.title': 'Tableau de Bord Analytique',
  'dashboard.totalBlocks': 'Total des Tentatives Bloquées',
  'dashboard.topCategories': 'Top des Catégories Bloquées',
  'dashboard.timeline': 'Chronologie des Blocages',
  
  'common.save': 'Sauvegarder',
  'common.load': 'Charger',
  'common.reset': 'Réinitialiser',
  'common.cancel': 'Annuler',
  'common.close': 'Fermer',
  'common.generate': 'Générer',
  'common.export': 'Exporter',
  'common.copy': 'Copier',
  'common.copied': 'Copié !',
  'common.error': 'Erreur',
  'common.success': 'Succès',
};
